import project1 from '../assets/images/project1.jpg';
import project2 from '../assets/images/project2.png';
import project4 from '../assets/images/project4.png';
import project5 from '../assets/images/project5.jpg';
import project6 from '../assets/images/project6.png';
import coverJpg from '../assets/images/trust-issues-cover.jpg';
import coverWebp from '../assets/images/trust-issues-cover.webp';

const WHATSAPP_TEXT =
  "Hi Ayaan, I came across your portfolio and wanted to get in touch about ...";

export const profile = {
  name: 'Ayaan Ahmad',
  firstName: 'Ayaan',
  role: 'Backend & AI Engineer',
  tagline: 'Building the systems behind AI products.',
  location: 'Dubai, UAE',
  timezone: 'Asia/Dubai',
  email: 'ayaanishere08@gmail.com',
  phoneDisplay: '+971 56 185 6219',
  cv: '/Ayaan_Ahmad_CV.pdf',
  links: {
    linkedin: 'https://www.linkedin.com/in/ayaan278/',
    github: 'https://github.com/ayaan278',
    devto: 'https://dev.to/ayaan278',
    whatsapp: `https://wa.me/971561856219?text=${encodeURIComponent(WHATSAPP_TEXT)}`,
    email: 'mailto:ayaanishere08@gmail.com?subject=Hello%20Ayaan',
  },
  availability: 'Open to interesting backend & AI problems',
};

export const nav = [
  { id: 'now', label: 'Now' },
  { id: 'work', label: 'Work' },
  { id: 'experience', label: 'Experience' },
  { id: 'about', label: 'About' },
  { id: 'writing', label: 'Writing' },
  { id: 'contact', label: 'Contact' },
];

export const heroStats = [
  { value: '3+', label: 'years shipping production backends' },
  { value: '2', label: 'countries, Malaysia to the UAE' },
  { value: '1', label: 'book, Trust Issues, on Kindle and paperback' },
];

/* ------------------------------------------------------------------
   NOW — what Ayaan is involved in, today
   ------------------------------------------------------------------ */
export const now = {
  updated: 'October 2026',
  items: [
    {
      id: 'risha',
      kind: 'Day job',
      org: 'AI Media Lab',
      title: 'Backend for Risha.ai',
      since: 'Nov 2025',
      status: 'live',
      body:
        'The region’s first integrated Arabic AI platform for content creators, launched at the Creators Gathering in Dubai. I build and maintain the backend: APIs, async processing, data pipelines and the LLM integrations that turn prompts into scripts, images, short videos and dubbing.',
      stack: ['FastAPI', 'Celery', 'Redis', 'PostgreSQL', 'OpenAI'],
      href: 'https://communicateonline.me/news/risha-ai-debuts-on-the-first-day-of-creators-gathering-in-dubai/',
      ctaLabel: 'Read about the launch',
    },
    {
      id: 'dfw',
      kind: 'Event platform',
      org: 'AI Media Lab',
      title: 'Dubai Future Week',
      since: 'Oct 2026',
      status: 'building',
      body:
        'The digital platform behind Dubai Future Week, 18\u201321 November 2026 across Emirates Towers and the Museum of the Future, organised by the Dubai Future Foundation for 10,000+ participants. Same remit as the summit: I own the backend end to end, from application APIs and data services to integrations and production infrastructure, and I will be onsite when it goes live.',
      stack: ['Django', 'PostgreSQL', 'GCP', 'Docker', 'Integrations'],
      href: 'https://www.dubaifutureweek.com/',
      ctaLabel: 'Event website',
    },
    {
      id: 'bfs',
      kind: 'Event platform',
      org: 'AI Media Lab',
      title: '1 Billion Followers Summit',
      since: 'Jan 2026',
      status: 'shipped',
      body:
        'Backend systems powering the digital platform of the world’s largest creator-economy summit: application APIs, data services, integrations and production infrastructure. On the ground during the live event, resolving issues in real time while the venue was full.',
      stack: ['Django', 'PostgreSQL', 'GCP', 'AWS', 'Docker'],
      href: 'https://www.1billionsummit.com',
      ctaLabel: 'Summit website',
    },
    {
      id: 'shapers',
      kind: 'Community',
      org: 'Sharjah Global Shapers Hub',
      title: 'Impact Officer, WEF initiative',
      since: 'Aug 2025',
      status: 'ongoing',
      body:
        'Selected as Impact Officer of the Sharjah Hub, a World Economic Forum initiative. Leading the “Navigating the World of the 21st Century” workshop series for youth; I hosted the opener on AI Fundamentals with a hands-on session on search algorithms and intelligent-agent design.',
      stack: ['Workshops', 'Youth programs', 'AI literacy'],
      href: 'https://www.sharjahglobalshapers.com/',
      ctaLabel: 'Sharjah Hub',
    },
    {
      id: 'writing',
      kind: 'Writing',
      org: 'Book & essays',
      title: 'Trust Issues, plus essays on AI agents',
      since: 'Aug 2026',
      status: 'ongoing',
      body:
        'Published Trust Issues: Working With Code You Didn\u2019t Write, a field manual for engineers shipping with AI agents, with the rules files and loop templates I use as a free toolkit. Between chapters I write on dev.to about loop engineering and the ways agents game test suites.',
      stack: ['Book', 'Loop engineering', 'AI agents', 'Testing'],
      href: '#writing',
      ctaLabel: 'See the writing',
    },
  ],
};

export const marquee = [
  'FastAPI',
  'Django',
  'Celery',
  'Redis',
  'PostgreSQL',
  'LangChain',
  'LlamaIndex',
  'RAG',
  'OpenAI',
  'GCP',
  'AWS',
  'Docker',
  'NestJS',
  'TypeScript',
  'Python',
  'React',
];

/* ------------------------------------------------------------------
   EXPERIENCE
   ------------------------------------------------------------------ */
export const experience = [
  {
    company: 'AI Media Lab',
    role: 'Backend AI Engineer',
    period: 'Nov 2025 — Present',
    location: 'Dubai, UAE',
    current: true,
    summary:
      'Backend owner across an AI content platform and Dubai\u2019s largest event platforms.',
    points: [
      'Risha.ai: built and maintain backend services for an AI-powered creator platform. APIs, asynchronous processing, data pipelines and LLM integrations on FastAPI, Celery, Redis, PostgreSQL and OpenAI.',
      '1 Billion Followers Summit: developed and supported the backend behind the summit’s digital platform, spanning application APIs, data services, integrations and production infrastructure on Django, PostgreSQL, GCP/AWS and Docker.',
      'Provided onsite technical support during the live event: issue resolution, system monitoring and coordination with technical teams.',
    ],
    stack: ['FastAPI', 'Django', 'Celery', 'Redis', 'PostgreSQL', 'GCP', 'AWS', 'Docker'],
  },
  {
    company: 'Falcon Lab AI',
    role: 'AI Software Developer',
    period: 'Mar 2025 — Aug 2025',
    location: 'Abu Dhabi, UAE (Remote)',
    summary: 'Led a legal-intelligence platform from zero to a working product.',
    points: [
      'BriefCounsel: led end-to-end development of a legal intelligence system for the UAE. Architected and engineered the platform from the ground up.',
      'Combined advanced Retrieval-Augmented Generation with meeting intelligence so lawyers get reference-backed answers and drafted documents instead of raw search results.',
    ],
    stack: ['Python', 'RAG', 'LLMs', 'Vector search', 'Next.js'],
  },
  {
    company: 'Docubutler.ai',
    role: 'Solution Architect',
    period: 'Dec 2024 — Feb 2025',
    location: 'Subang Jaya, Malaysia',
    summary: 'AI features that moved real product metrics.',
    points: [
      'Engineered an AI-based recommendation system that increased user engagement by 20%.',
      'Designed an AI-driven document digitization tool that automated document processing and improved operational efficiency by 30%.',
    ],
    stack: ['NestJS', 'Node.js', 'MongoDB', 'Google Cloud'],
  },
  {
    company: 'Kalsym Sdn. Bhd.',
    role: 'Software Engineer',
    period: 'Jul 2023 — Nov 2024',
    location: 'Subang Jaya, Malaysia',
    href: 'https://www.kalsym.com/',
    summary: 'Backend systems for telecom-scale B2B and SIM applications.',
    points: [
      'Designed and developed backend systems to analyse user behaviour; built a recommendation system that lifted retention and engagement by 15%.',
      'Contributed to global profiling systems and customer loyalty services in B2B/SIM applications, improving customer satisfaction rates.',
      'Developed fraud detection modules that secured the system and reduced fraudulent activity by 25%.',
    ],
    stack: ['NestJS', 'TypeScript', 'MySQL', 'MongoDB', 'Azure'],
  },
];

/* ------------------------------------------------------------------
   WORK — selected projects
   ------------------------------------------------------------------ */
export const featuredWork = [
  {
    id: 'briefcounsel',
    index: '01',
    title: 'BriefCounsel',
    kicker: 'Legal intelligence for the UAE',
    year: '2025',
    org: 'Falcon Lab AI',
    description:
      'A legal intelligence platform built from the ground up. Fine-tuned LLMs and retrieval-augmented generation over UAE law, fused with meeting intelligence, so legal professionals get instant reference-backed answers and automated document drafting.',
    tags: ['RAG', 'LLM fine-tuning', 'Vector search', 'Meeting intelligence'],
    award: null,
    href: 'https://briefcounsel.ae',
    cta: 'Visit briefcounsel.ae',
    cover: { type: 'generated', glyph: 'B', hue: 'ember' },
  },
  {
    id: 'quickgrade',
    index: '02',
    title: 'QuickGrade',
    kicker: 'AI grading for subjective answers',
    year: '2023 — 2024',
    org: 'Final year project, MMU',
    description:
      'An automatic grading system that scores free-text answers with NLP and semantic analysis, blending edit, cosine and Jaccard similarity with Universal Sentence Encoder embeddings. Cut manual grading time by over 80% and flags the answers that still need a human.',
    tags: ['Django', 'TensorFlow', 'NLTK', 'Semantic similarity'],
    award: '1st Runner-up, Best Final Year Project (Software Engineering)',
    href: 'https://youtu.be/AJyIaeSjcUI',
    cta: 'Watch the demo',
    cover: { type: 'image', src: project2, alt: 'QuickGrade landing page' },
  },
  {
    id: 'unicab',
    index: '03',
    title: 'Unicab',
    kicker: 'E-hailing for university students',
    year: '2023',
    org: 'InventX 2023',
    description:
      'A React Native ride-hailing app for campus life, with real-time tracking, booking and payments, plus a matching algorithm that pools nearby riders heading to the same class.',
    tags: ['React Native', 'Node.js', 'MySQL', 'Azure'],
    award: 'Best of the Best Project, Computing & Informatics, InventX 2023',
    href: 'https://youtu.be/kMa0IuTAKRM',
    cta: 'Watch the demo',
    cover: { type: 'image', src: project4, alt: 'Unicab passenger screens', fit: 'contain', bg: '#000' },
  },
  {
    id: 'traffic',
    index: '04',
    title: 'Traffic Light Recognition Assistance',
    kicker: 'Computer vision for the visually impaired',
    year: '2022',
    org: 'Huawei Developer Competition',
    description:
      'A custom object-detection model trained on Huawei ModelArts to recognise traffic lights at 85% accuracy, paired with a React Native app that gives real-time auditory feedback on the signal state.',
    tags: ['Huawei ModelArts', 'React Native', 'Firebase', 'Object detection'],
    award: 'Honorable Student Award, Huawei Developer Competition 2022',
    href: 'https://github.com/ayaan278/Traffic-Recognition',
    cta: 'View on GitHub',
    cover: { type: 'image', src: project1, alt: 'Traffic light detection app screens' },
  },
];

export const moreWork = [
  {
    title: 'Beam \u2014 QR code, send to phone',
    description:
      'Chrome extension that turns whatever you are looking at into a QR code, so a page goes from laptop to phone in one scan. The successor to my first QR extension, which passed 4,000 users before I sold it.',
    tags: ['Chrome extension', 'QR', 'Utility'],
    href: 'https://chromewebstore.google.com/detail/beam-%E2%80%94-qr-code-send-to-ph/njjcajbhpkbkimdbofgpkcddogngiajd',
    glyph: 'QR',
  },
  {
    title: 'Meowminder \u2014 cute cat reminders',
    description:
      'An experiment: a little cat peeks in from the edge of your screen to deliver reminders, water breaks and routines, all stored locally. Started as a Chrome extension, then grew into a desktop app with a 3D companion cat named Mochi.',
    tags: ['Chrome extension', 'Desktop app', 'Experiment'],
    href: 'https://chromewebstore.google.com/detail/meowminder-%E2%80%94-cute-cat-rem/lnjpdeeinahpgmldhhkdjajolmjaikke',
    secondary: { label: 'Desktop app on itch.io', href: 'https://ayaan278.itch.io/meowminder' },
    glyph: '\uD83D\uDC31',
  },
  {
    title: 'SAS Travels & Tourism',
    description: 'Marketing site for a travel agency, built with React and Chakra UI.',
    tags: ['React', 'Chakra UI'],
    href: 'http://sas-travels.com/',
    image: project5,
  },
  {
    title: 'MMU IT Society website',
    description: 'Official site for the university IT Society. I also designed the algorithmic problems for Hack@MMU 2022 and CodeNection 2022.',
    tags: ['React', 'Competitive programming'],
    href: 'https://itsociety.rocks/',
    image: project6,
  },
];

/* ------------------------------------------------------------------
   SKILLS
   ------------------------------------------------------------------ */
export const skills = [
  {
    group: 'Backend',
    items: ['FastAPI', 'Django', 'NestJS', 'Node.js', 'Flask', 'Spring Boot', 'Celery', 'REST & async APIs'],
    featured: true,
  },
  {
    group: 'AI & LLM systems',
    items: ['LangChain', 'LlamaIndex', 'OpenAI', 'RAG pipelines', 'TensorFlow', 'Scikit-learn', 'NLTK', 'Vector search'],
    featured: true,
  },
  {
    group: 'Data',
    items: ['PostgreSQL', 'Redis', 'MySQL', 'MongoDB', 'Firebase', 'Pinecone'],
  },
  {
    group: 'Cloud & DevOps',
    items: ['GCP', 'AWS', 'Azure', 'Huawei Cloud', 'Docker', 'CI/CD', 'Git'],
  },
  {
    group: 'Languages',
    items: ['Python', 'TypeScript', 'JavaScript', 'Java', 'C++'],
  },
  {
    group: 'Frontend',
    items: ['React', 'Next.js', 'React Native', 'Angular'],
  },
];

export const certifications = [
  { name: 'Adversarial Machine Learning', issuer: 'NVIDIA' },
  { name: 'Prompt Engineering', issuer: 'NVIDIA' },
  { name: 'Vertex AI', issuer: 'Google Cloud' },
];

/* ------------------------------------------------------------------
   WRITING — the book, essays and research
   ------------------------------------------------------------------ */
export const book = {
  title: 'Trust Issues',
  subtitle: 'Working With Code You Didn\u2019t Write',
  tagline: 'A field manual for the AI era',
  blurb: 'A working engineer\u2019s guide to loop engineering, MCP, and shipping with AI.',
  description:
    'Most of the code I ship now was written by an agent. This is the book about what that does to an engineer: how trust gets rebuilt one verified loop at a time, where it still breaks, and how to stay useful when the code writes itself. Field notes, not theory, with the rules files and loop templates from the appendix released free.',
  living:
    'Written to be revised. The title is a working one, and new chapters land as the tooling, and my opinions about it, change.',
  year: '2026',
  formats: ['Kindle', 'Paperback'],
  themes: ['Trust', 'Change', 'Judgment', 'Work'],
  chapters: [
    'My Stack Didn\u2019t Change \u2014 I Did',
    'The 67/68 Problem',
    'Teaching It Your World: Rules, Skills, and MCP',
    'Where I Still Don\u2019t Trust It',
    'Juice on the Couch',
    'The Duct Tape Setup',
    'Staying Employable When the Code Writes Itself',
    'Are We There Yet?',
  ],
  cover: { webp: coverWebp, jpg: coverJpg, alt: 'Trust Issues book cover: torn paper revealing the title in black and yellow' },
  links: {
    kindle: 'https://www.amazon.com/dp/B0HD7D3DQ9',
    paperback: 'https://www.amazon.com/dp/B0HL5DK2K6',
    sample: 'https://ayaan278.github.io/trust-issues-toolkit/chapter-2.html',
    toolkit: 'https://github.com/ayaan278/trust-issues-toolkit',
  },
};

export const writing = [
  {
    type: 'Essay',
    title: 'Seven ways AI agents cheat on tests. Three of them got me.',
    venue: 'dev.to',
    date: 'Sep 2026',
    description:
      'The ways autonomous coding agents game a test suite, from editing assertions to rewriting tests that look outdated, and the rules files that caught them.',
    href: 'https://dev.to/ayaan278/seven-ways-ai-agents-cheat-on-tests-three-of-them-got-me-1l3b',
    cta: 'Read on dev.to',
  },
  {
    type: 'Essay',
    title: 'Loop engineering: stop prompting, start defining outcomes',
    venue: 'dev.to',
    date: 'Aug 2026',
    description:
      'Why one-shot prompting plateaus, and how a bounded loop that changes one thing per attempt, keeps a log and commits each try gets agents to a real outcome.',
    href: 'https://dev.to/ayaan278/loop-engineering-stop-prompting-start-defining-outcomes-lho',
    cta: 'Read on dev.to',
  },
  {
    type: 'Paper',
    title: 'Automated grading using natural language processing and semantic analysis',
    venue: 'MethodsX (Elsevier), peer-reviewed',
    date: '2025',
    description:
      'The architecture and evaluation behind QuickGrade: a weighted combination of similarity measures and sentence-embedding semantics for grading free-text answers.',
    href: 'https://doi.org/10.1016/j.mex.2025.103395',
    cta: 'Read on ScienceDirect',
  },
];

/* ------------------------------------------------------------------
   EDUCATION & RECOGNITION
   ------------------------------------------------------------------ */
export const education = {
  school: 'Multimedia University',
  degree: 'B.Sc. (Hons) Computer Science',
  period: 'May 2021 — Nov 2024',
  location: 'Cyberjaya, Malaysia',
  gpa: 'CGPA 3.75 / 4.0',
  notes: [
    'Dean’s Honor List for five consecutive semesters.',
    'Book Award for Academic Excellence.',
    'Technical Member, MMU IT Society (2022 — 2023): built the society website and set problems for Hack@MMU 2022 and CodeNection 2022.',
  ],
};

export const awards = [
  { title: 'Best of the Best Project', detail: 'InventX 2023, Computing & Informatics', year: '2023' },
  { title: '1st Runner-up, Best Final Year Project', detail: 'Software Engineering category', year: '2024' },
  { title: 'Honorable Student Award', detail: 'Huawei Developer Competition', year: '2022' },
  { title: 'Dean’s Honor List', detail: 'Five consecutive semesters', year: '2021 — 2024' },
  { title: 'Book Award for Academic Excellence', detail: 'Multimedia University', year: '2024' },
];

export const about = {
  intro:
    'I’m a backend engineer who ended up building AI products, which turns out to be the same job with higher stakes: the model is the easy part, the system around it is where things break.',
  paragraphs: [
    'I started in Malaysia at Kalsym, writing telecom-scale backend services, fraud detection and recommendation engines. From there I moved into AI-first products: document digitization at Docubutler, a legal-intelligence platform at Falcon Lab AI, and now Risha.ai and the 1 Billion Followers Summit platform at AI Media Lab in Dubai.',
    'What I care about is the unglamorous middle: queue design, idempotent workers, data models that survive the second product pivot, and LLM integrations with a budget, a timeout and a fallback. I like being on the ground when things go live.',
    'Outside work I serve as Impact Officer at the Sharjah Global Shapers Hub, running workshops that teach young people how AI actually works, and I wrote Trust Issues, a field manual for working with code you didn\u2019t write.',
  ],
  principles: [
    { k: 'Boring on purpose', v: 'Postgres, queues and plain HTTP before anything exotic.' },
    { k: 'Measure the lift', v: 'Every AI feature ships with a metric it is supposed to move.' },
    { k: 'Own the pager', v: 'If I built it, I can debug it at 2am and explain it at 9am.' },
  ],
};
